module.exports = __webpack_public_path__ + "static/img/pay-zfb.126c4c48.jpg";